import React from 'react';
import { ApolloClient, createNetworkInterface, ApolloProvider } from 'react-apollo';
import { connect } from 'react-redux';

import CoreLayout from './layouts/PageLayout/PageLayout';
import LinkedinSignin from './routes/LinkedInSignin';

const mapStateToProps = (state) => ({
  authedUserID: state.auth.sub || null,
  authedUser: state.auth || null,
});

export const createRoutes = (store) => {
  return ({
    path: 'signin',
    component: connect(mapStateToProps)(props => {
      const GraphQLURI = __GraphQLPublic; // eslint-disable-line no-undef

      const ApolloNetworkInstance = createNetworkInterface({
        uri: GraphQLURI,
        opts: {
          headers: {
            'Authorization': 'Bearer ' + (props.authedUser.rawToken || 'unauthed'),
          }
        }
      });

      const ApolloClientInstance = new ApolloClient({
        networkInterface: ApolloNetworkInstance,
      });

      return (
        <ApolloProvider client={ApolloClientInstance}>
          <CoreLayout store={store} {...props} />
        </ApolloProvider>
      );
    }),
    childRoutes: [
      LinkedinSignin(store),
    ]
  });
};

export default createRoutes;



// WEBPACK FOOTER //
// ./src/routes/signin/index.js